const Css = {
  SlideLimit:{
    width: "12px",
    height: "140px",
    marginTop: "72px",
    borderTopWidth: "1px",
    borderTopStyle: "solid",
    borderTopColor: "#999",
    borderBottonWidth: "1px",
    borderBottonStyle: "solid",
    borderBottonColor: "#999",
    cursor: "pointer",
  },
  Mark(i){
    let w = "5px";
    let color = "#666";
    if(i%2 === 1){
      w = "12px";
      color = "#999";
    }
    return {
      width: w,
      height: "1px",
      backgroundColor: color,
      marginTop: "6px",
      float:"left"
    }
  },
  MaxCoverDiv(h=66){
    return {
      width: "12px",
      backgroundColor: "#191A1B",
      position: "absolute",
      top: "0px",
      height: h + "px",
      cursor: "pointer",
      opacity: 0.7,
      filter: "alpha(opacity=70)",
      MozOpacity: 0.7,
    }
  },
  LevelMaxBtn(mt=66){
    return {
      cursor: "pointer",
      zIndex: 3,
      float: "left",
      top: mt + "px",
      height: "6px",
      position: "absolute"
    }
  },
  MinCoverDiv(h){
    return {
      width: "12px",
      backgroundColor: "#191A1B",
      position: "absolute",
      bottom: 0,
      height: h + "px",
      zIndex: 3,
      cursor: "pointer",
      opacity: 0.7,
      filter: "alpha(opacity=70)",
      MozOpacity: 0.7,
    }
  },
  LevelMinBtn(mb){
    return{
      cursor: "pointer",
      zIndex: 3,
      float: "left",
      height: "6px",
      bottom: mb + "px",
      left: 0,
      position: "absolute"
    }
  },
  
}

export default Css;